import React from "react";
import { Prompt } from "react-router-dom";

const CustomPrompt = ({ message }) => {
  return <Prompt when={true} message={message} />;
};

export default CustomPrompt;
